import { render, staticRenderFns } from "./quotation-author.vue?vue&type=template&id=64708fb0&scoped=true&"
import script from "./quotation-author.vue?vue&type=script&lang=js&"
export * from "./quotation-author.vue?vue&type=script&lang=js&"
import style0 from "./quotation-author.vue?vue&type=style&index=0&id=64708fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64708fb0",
  null
  
)

export default component.exports